export const ANNUAL_ACCOUNT_REPORT_ACCEPTED = "ANNUAL_ACCOUNT_REPORT_ACCEPTED";
export const ANNUAL_ACCOUNT_REPORT_REJECTED = "ANNUAL_ACCOUNT_REPORT_REJECTED";
export const ANNUAL_ACCOUNT_REPORT_COMMENTED = "ANNUAL_ACCOUNT_REPORT_COMMENTED";
export const ANNUAL_ACCOUNT_REPORT_SNOOZED = "ANNUAL_ACCOUNT_REPORT_SNOOZED";
